import styled from 'styled-components';

import { Sidebar as SidebarBase } from 'react-pro-sidebar';

export const Sidebar = styled(SidebarBase)`
  position: sticky !important;
  top: 0;
`;
